/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

var loadingDefaultProps = {
  delay: 0,
  fullscreen: false,
  indicator: true,
  inheritColor: false,
  loading: true,
  preventScrollThrough: true,
  showOverlay: true,
  size: "medium"
};

export { loadingDefaultProps };
//# sourceMappingURL=defaultProps.js.map
